<!-- New admission form (v2 restyled wizard) -->
<div class="modal fade newadmission-v2-wrapper" id="newadmission-v2" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
  aria-hidden="true" data-backdrop="false">
  <div class="modal-dialog adv2-modal-dialog">
    <div class="modal-content adv2-modal-content">

      <!-- Sticky header -->
      <div class="adv2-mhead">
        <div class="adv2-mhead-left">
          <div class="adv2-mhead-text">
            <h3 class="adv2-title">{{ 'header.newAdmission' | translate }}</h3>
          </div>
        </div>
        <div class="adv2-mhead-actions">
          <button type="button" id="close-modal" class="close adv2-close-btn" (click)="onAttemptCloseModal()" aria-hidden="true">
            <i class="ph-bold ph-x"></i>
          </button>
        </div>
      </div>

      <!-- Close confirmation overlay -->
      <div class="adv2-confirm-overlay" *ngIf="showCloseConfirm">
        <div class="adv2-confirm-box">
          <div class="adv2-confirm-icon"><i class="ph-bold ph-warning-circle"></i></div>
          <h4 class="adv2-confirm-title">{{ 'header.closeThisForm' | translate }}</h4>
          <p class="adv2-confirm-text">{{ 'header.loseAllInformationWarning' | translate }}</p>
          <div class="adv2-confirm-actions">
            <button type="button" class="adv2-btn adv2-btn-secondary" (click)="cancelCloseConfirm()">{{ 'header.cancel' | translate }}</button>
            <button type="button" class="adv2-btn adv2-btn-danger" (click)="confirmCloseModal()">{{ 'header.closeAndDiscard' | translate }}</button>
          </div>
        </div>
      </div>

      <!-- Unsaved document selection confirmation overlay -->
      <div class="adv2-confirm-overlay" *ngIf="showUnsavedDocumentConfirm">
        <div class="adv2-confirm-box">
          <div class="adv2-confirm-icon"><i class="ph-bold ph-warning-circle"></i></div>
          <h4 class="adv2-confirm-title">{{ 'header.unuploadedDocumentTitle' | translate }}</h4>
          <p class="adv2-confirm-text">{{ 'header.unuploadedDocumentWarning' | translate }}</p>
          <div class="adv2-confirm-actions">
            <button type="button" class="adv2-btn adv2-btn-secondary" (click)="cancelUnsavedDocumentConfirm()">{{ 'header.addDocument' | translate }}</button>
            <button type="button" class="adv2-btn adv2-btn-danger" (click)="discardUnsavedDocumentAndFinish()">{{ 'header.closeAndDiscard' | translate }}</button>
          </div>
        </div>
      </div>

      <!-- Stepper -->
      <div class="adv2-stepper" *ngIf="!showPostAdmissionDocumentsStep">
        <ng-container *ngFor="let label of stepLabels; let i = index">
          <div class="adv2-step" [class.active]="currentStep === i + 1" [class.done]="currentStep > i + 1"
            (click)="goToStep(i + 1)" title="{{ label | translate }}">
            <div class="adv2-step-dot">
              <i class="ph-bold ph-check" *ngIf="currentStep > i + 1"></i>
              <span *ngIf="currentStep <= i + 1">{{i + 1}}</span>
            </div>
            <span class="adv2-step-label">{{ label | translate }}</span>
          </div>
          <div class="adv2-step-connector" [class.done]="currentStep > i + 1" *ngIf="i < stepLabels.length - 1"></div>
        </ng-container>
      </div>

      <!-- ============ Supporting Documents — shown after successful registration ============ -->
      <div class="modal-body adv2-mbody" *ngIf="showPostAdmissionDocumentsStep">
        <div class="adv2-section-card">
          <h4 class="adv2-section-title">{{ 'header.supportingDocuments' | translate }}</h4>
          <p class="adv2-section-subtitle">
            {{ 'header.supportingDocumentsHelpTextFor' | translate }} <span class="adv2-docupload-student-name">{{ reviewStudentName }}</span>
          </p>

          <div class="adv2-docupload-loader" *ngIf="fetchingDocumentTypesForAdmission">
            <app-button-loader></app-button-loader>
          </div>

          <ng-container *ngIf="!fetchingDocumentTypesForAdmission">
            <div class="adv2-docupload-empty" *ngIf="documentTypesForAdmission.length === 0">
              {{ 'header.noDocumentTypesConfigured' | translate }}
            </div>

            <div class="adv2-docupload-form" *ngIf="documentTypesForAdmission.length > 0">
              <div class="form-group">
                <label>{{ 'documentType' | translate }} <span class="mandatory"><sup>*</sup></span></label>
                <select class="form-control" [(ngModel)]="admissionDocDraft.docType" [ngModelOptions]="{standalone: true}">
                  <option [ngValue]="null" hidden>{{ 'selectDocument' | translate }}</option>
                  <option *ngFor="let item of documentTypesForAdmission" [ngValue]="item">{{ item.documentTypeName }}</option>
                </select>
              </div>

              <div class="form-group" *ngIf="admissionDocDraft.docType?.documentTypeName === 'Other'">
                <label>{{ 'documentTitle' | translate }} <span class="mandatory"><sup>*</sup></span></label>
                <input type="text" class="form-control" maxlength="50" [(ngModel)]="admissionDocDraft.title" [ngModelOptions]="{standalone: true}" />
              </div>

              <div class="form-group">
                <label>{{ 'documentDescription' | translate }}</label>
                <textarea class="form-control" rows="3" maxlength="200" [(ngModel)]="admissionDocDraft.description" [ngModelOptions]="{standalone: true}"></textarea>
              </div>

              <div class="form-group">
                <label>{{ 'uploadDocument' | translate }} <span class="mandatory"><sup>*</sup></span></label>
                <label class="adv2-docupload-file-label" [class.adv2-docupload-file-selected]="admissionDocDraft.file">
                  <i class="ri-attachment-2"></i>
                  <span>{{ admissionDocDraft.file ? admissionDocDraft.file.name : ('header.chooseFile' | translate) }}</span>
                  <input type="file" [accept]="admissionDocDraft.docType?.allowedFormat" (change)="onAdmissionDraftFileSelected($event)" />
                </label>
              </div>

              <div class="adv2-docupload-add-row">
                <button type="button" class="adv2-btn adv2-btn-secondary" [disabled]="uploadingAdmissionDocument" (click)="uploadAdmissionDocument()">
                  <span *ngIf="!uploadingAdmissionDocument">{{ 'header.addDocument' | translate }}</span>
                  <app-button-loader *ngIf="uploadingAdmissionDocument"></app-button-loader>
                </button>
              </div>
            </div>

            <div class="adv2-docupload-list" *ngIf="pendingAdmissionDocuments.length > 0">
              <div class="adv2-docupload-row" *ngFor="let doc of pendingAdmissionDocuments; let i = index">
                <div class="adv2-docupload-info">
                  <span class="adv2-docupload-name">{{ doc.documentTitle || doc.documentTypeName }}</span>
                  <span class="adv2-docupload-filename" *ngIf="doc.documentTitle && doc.documentTypeName">{{ doc.documentTypeName }}</span>
                </div>
                <div class="adv2-docupload-row-actions">
                  <button type="button" class="adv2-docupload-preview" [disabled]="previewingAdmissionDocumentIndex === i || deletingAdmissionDocumentIndex !== null"
                    title="{{ 'header.preview' | translate }}" (click)="previewAdmissionUploadedDocument(doc, i)">
                    <i class="ri-eye-line" *ngIf="previewingAdmissionDocumentIndex !== i"></i>
                    <app-button-loader *ngIf="previewingAdmissionDocumentIndex === i"></app-button-loader>
                  </button>
                  <button type="button" class="adv2-docupload-remove" [disabled]="deletingAdmissionDocumentIndex === i || previewingAdmissionDocumentIndex !== null"
                    title="{{ 'delete' | translate }}" (click)="deleteAdmissionDocument(doc, i)">
                    <i class="ri-delete-bin-line" *ngIf="deletingAdmissionDocumentIndex !== i"></i>
                    <app-button-loader *ngIf="deletingAdmissionDocumentIndex === i"></app-button-loader>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="modal-body adv2-mbody" *ngIf="!showPostAdmissionDocumentsStep">
        <form class="form">

          <!-- ============ STEP 1: Basic Info ============ -->
          <section class="adv2-panestep" [class.active]="currentStep === 1" [hidden]="currentStep !== 1">
            <div class="adv2-section-card">
              <h4 class="adv2-section-title">{{ 'header.studentBasicInfo' | translate }}</h4>
              <div class="adv2-grid adv2-grid-3">
                <div class="form-group">
                  <input (change)="changeStudName(mStudentName)" [(ngModel)]="mStudentName"
                    [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="admission-student-name"
                    maxlength="100" placeholder="{{ 'header.firstName' | translate }}">
                  <label for="admission-student-name">{{ 'header.studentName' | translate }}<span style="color: #F44336;">*</span></label>
                </div>
                <div class="form-group">
                  <input (change)="changeSurName(mSurName)" [(ngModel)]="mSurName"
                    [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="admission-surname"
                    maxlength="50" placeholder="{{ 'header.surname' | translate }}">
                  <label for="admission-surname">{{ 'header.surname' | translate }}</label>
                </div>
                <div class="form-group">
                  <select [(ngModel)]="mGenderGroup" [ngModelOptions]="{standalone: true}" id="admission-gender-group"
                    name="select1" class="form-control">
                    <option value="" disabled>{{ 'header.selectGender' | translate }}</option>
                    <option id="admission-gender-male" value="1">{{ 'header.male' | translate }}</option>
                    <option id="admission-gender-female" value="0">{{ 'header.female' | translate }}</option>
                  </select>
                  <label for="admission-gender-group">{{ 'header.gender' | translate }}<span style="color: #F44336;">*</span></label>
                </div>
                <div class="form-group contact-number-student">
                  <p-calendar  [(ngModel)]="mDOBDate" [ngModelOptions]="{standalone: true}" inputId="admission-v2-dob"
                    styleClass="adv2-calendar" dateFormat="dd/mm/yy" [maxDate]="today" [showIcon]="true"
                    appendTo="body" (onSelect)="changeDOB($event)" placeholder="{{ 'header.ddmmyyyy' | translate }}"></p-calendar>
                  <label for="admission-v2-dob">{{ 'header.dateOfBirth' | translate }}<span style="color: #F44336;">* </span> ({{ 'header.ddmmyyyy' | translate }}
                    )</label>
                </div>

                <div class="form-group">
                  <select [(ngModel)]="mBloodGroup" [ngModelOptions]="{standalone: true}" id="admission-blood-group"
                    name="select1" class="form-control">
                    <option value="" disabled>{{ 'header.selectBloodGroup' | translate }}</option>
                    <option value="A+">{{ 'header.a+' | translate }}</option>
                    <option value="A-">{{ 'header.a-' | translate }}</option>
                    <option value="B+">{{ 'header.b+' | translate }}</option>
                    <option value="B-">{{ 'header.b-' | translate }}</option>
                    <option value="AB+">{{ 'header.ab+' | translate }}</option>
                    <option value="AB-">{{ 'header.ab-' | translate }}</option>
                    <option value="O+">{{ 'header.o+' | translate }}</option>
                    <option value="O-">{{ 'header.o-' | translate }}</option>
                  </select>
                  <label for="admission-blood-group">{{ 'header.bloodGroup' | translate }}<span style="color: #F44336;">*</span></label>
                </div>
                <div class="form-group">
                  <select [(ngModel)]="mReligion" [ngModelOptions]="{standalone: true}" id="admission-religion"
                    name="select1" class="form-control">
                    <option value="" disabled>{{ 'header.selectReligion' | translate }}</option>
                    <option value="Hindu">{{ 'header.hindu' | translate }}</option>
                    <option value="Christian">{{ 'header.christian' | translate }}</option>
                    <option value="Muslim">{{ 'header.muslim' | translate }}</option>
                    <option value="Other">{{ 'header.other' | translate }}</option>
                  </select>
                  <label for="admission-religion">{{ 'header.religion' | translate }}<span style="color: #F44336;">*</span></label>
                </div>

                <div class="form-group">
                  <input (change)="changeCaste(mCast)" [(ngModel)]="mCast" [ngModelOptions]="{standalone: true}"
                    type="text" class="form-control" id="admission-cast" placeholder="{{ 'header.general' | translate }}">
                  <label for="admission-cast">{{ 'header.caste' | translate }}</label>
                </div>

                <div class="form-group">
                  <select [(ngModel)]="mNationality" [ngModelOptions]="{standalone: true}" id="admission-nationality"
                    name="select1" class="form-control">
                    <option value="" disabled>{{ 'header.selectNationality' | translate }}</option>
                    <option value="Afghan">{{ 'header.afghan' | translate }}</option>
                    <option value="Albanian">{{ 'header.albanian' | translate }}</option>
                    <option value="Algerian">{{ 'header.algerian' | translate }}</option>
                    <option value="Andorran">{{ 'header.andorran' | translate }}</option>
                    <option value="Angolan">{{ 'header.angolan' | translate }}</option>
                    <option value="Argentinian">{{ 'header.argentinian' | translate }}</option>
                    <option value="Armenian">{{ 'header.armenian' | translate }}</option>
                    <option value="Australian">{{ 'header.australian' | translate }}</option>
                    <option value="Austrian">{{ 'header.austrian' | translate }}</option>
                    <option value="Azerbaijani">{{ 'header.azerbaijani' | translate }}</option>
                    <option value="Bahamian">{{ 'header.bahamian' | translate }}</option>
                    <option value="Bangladeshi">{{ 'header.bangladeshi' | translate }}</option>
                    <option value="Barbadian">{{ 'header.barbadian' | translate }}</option>
                    <option value="Belorussian">{{ 'header.belorussian' | translate }}</option>
                    <option value="Belgian">{{ 'header.belgian' | translate }}</option>
                    <option value="Beninese">{{ 'header.beninese' | translate }}</option>
                    <option value="Bhutanese">{{ 'header.bhutanese' | translate }}</option>
                    <option value="Bolivian">{{ 'header.bolivian' | translate }}</option>
                    <option value="Bosnian">{{ 'header.bosnian' | translate }}</option>
                    <option value="Brazilian">{{ 'header.brazilian' | translate }}</option>
                    <option value="Briton">{{ 'header.briton' | translate }}</option>
                    <option value="Bruneian">{{ 'header.bruneian' | translate }}</option>
                    <option value="Bulgarian">{{ 'header.bulgarian' | translate }}</option>
                    <option value="Burmese">{{ 'header.burmese' | translate }}</option>
                    <option value="Burundian">{{ 'header.burundian' | translate }}</option>
                    <option value="Cambodian">{{ 'header.cambodian' | translate }}</option>
                    <option value="Cameroonian">{{ 'header.cameroonian' | translate }}</option>
                    <option value="Canadian">{{ 'header.canadian' | translate }}</option>
                    <option value="Chadian">{{ 'header.chadian' | translate }}</option>
                    <option value="Chilean">{{ 'header.chilean' | translate }}</option>
                    <option value="Chinese">{{ 'header.chinese' | translate }}</option>
                    <option value="Colombian">{{ 'header.colombian' | translate }}</option>
                    <option value="Congolese">{{ 'header.congolese' | translate }}</option>
                    <option value="Croatian">{{ 'header.croatian' | translate }}</option>
                    <option value="Cuban">{{ 'header.cuban' | translate }}</option>
                    <option value="Cypriot">{{ 'header.cypriot' | translate }}</option>
                    <option value="Czech">{{ 'header.czech' | translate }}</option>
                    <option value="Dane">{{ 'header.dane' | translate }}</option>
                    <option value="Dominican">{{ 'header.dominican' | translate }}</option>
                    <option value="Ecuadorean">{{ 'header.ecuadorean' | translate }}</option>
                    <option value="Egyptian">{{ 'header.egyptian' | translate }}</option>
                    <option value="Salvadorean">{{ 'header.salvadorean' | translate }}</option>
                    <option value="Englishman">{{ 'header.englishman' | translate }}</option>
                    <option value="Eritrean">{{ 'header.eritrean' | translate }}</option>
                    <option value="Estonian">{{ 'header.estonian' | translate }}</option>
                    <option value="Ethiopian">{{ 'header.ethiopian' | translate }}</option>
                    <option value="Fijian">{{ 'header.fijian' | translate }}</option>
                    <option value="Finn">{{ 'header.finn' | translate }}</option>
                    <option value="Frenchman">{{ 'header.frenchman' | translate }}</option>
                    <option value="Gabonese">{{ 'header.gabonese' | translate }}</option>
                    <option value="Gambian">{{ 'header.gambian' | translate }}</option>
                    <option value="Georgian">{{ 'header.georgian' | translate }}</option>
                    <option value="German">{{ 'header.german' | translate }}</option>
                    <option value="Ghanaian">{{ 'header.ghanaian' | translate }}</option>
                    <option value="Greek">{{ 'header.greek' | translate }}</option>
                    <option value="Grenadian">{{ 'header.grenadian' | translate }}</option>
                    <option value="Guatemalan">{{ 'header.guatemalan' | translate }}</option>
                    <option value="Guinean">{{ 'header.guinean' | translate }}</option>
                    <option value="Guyanese">{{ 'header.guyanese' | translate }}</option>
                    <option value="Haitian">{{ 'header.haitian' | translate }}</option>
                    <option value="Dutchman">{{ 'header.dutchman' | translate }}</option>
                    <option value="Honduran">{{ 'header.honduran' | translate }}</option>
                    <option value="Hungarian">{{ 'header.hungarian' | translate }}</option>
                    <option value="Icelander">{{ 'header.icelander' | translate }}</option>
                    <option value="Indian">{{ 'header.indian' | translate }}</option>
                    <option value="Indonesian">{{ 'header.indonesian' | translate }}</option>
                    <option value="Iranian">{{ 'header.iranian' | translate }}</option>
                    <option value="Iraqi">{{ 'header.iraqi' | translate }}</option>
                    <option value="Irishman">{{ 'header.irishman' | translate }}</option>
                    <option value="Israeli">{{ 'header.israeli' | translate }}</option>
                    <option value="Italian">{{ 'header.italian' | translate }}</option>
                    <option value="Jamaican">{{ 'header.jamaican' | translate }}</option>
                    <option value="Japanese">{{ 'header.japanese' | translate }}</option>
                    <option value="Jordanian">{{ 'header.jordanian' | translate }}</option>
                    <option value="Kazakh">{{ 'header.kazakh' | translate }}</option>
                    <option value="Kenyan">{{ 'header.kenyan' | translate }}</option>
                    <option value="Korean">{{ 'header.korean' | translate }}</option>
                    <option value="Kuwaiti">{{ 'header.kuwaiti' | translate }}</option>
                    <option value="Laotian">{{ 'header.laotian' | translate }}</option>
                    <option value="Latvian">{{ 'header.latvian' | translate }}</option>
                    <option value="Lebanese">{{ 'header.lebanese' | translate }}</option>
                    <option value="Liberian">{{ 'header.liberian' | translate }}</option>
                    <option value="Libyan">{{ 'header.libyan' | translate }}</option>
                    <option value="Liechtensteiner">{{ 'header.liechtensteiner' | translate }}</option>
                    <option value="Lithuanian">{{ 'header.lithuanian' | translate }}</option>
                    <option value="Luxembourger">{{ 'header.luxembourger' | translate }}</option>
                    <option value="Macedonian">{{ 'header.macedonian' | translate }}</option>
                    <option value="Madagascan">{{ 'header.madagascan' | translate }}</option>
                    <option value="Malawian">{{ 'header.malawian' | translate }}</option>
                    <option value="Malaysian">{{ 'header.malaysian' | translate }}</option>
                    <option value="Maldivian">{{ 'header.maldivian' | translate }}</option>
                    <option value="Malian">{{ 'header.malian' | translate }}</option>
                    <option value="Maltese">{{ 'header.maltese' | translate }}</option>
                    <option value="Mauritanian">{{ 'header.mauritanian' | translate }}</option>
                    <option value="Mauritian">{{ 'header.mauritian' | translate }}</option>
                    <option value="Mexican">{{ 'header.mexican' | translate }}</option>
                    <option value="Moldovan">{{ 'header.moldovan' | translate }}</option>
                    <option value="Monacan">{{ 'header.monacan' | translate }}</option>
                    <option value="Mongolian">{{ 'header.mongolian' | translate }}</option>
                    <option value="Montenegrin">{{ 'header.montenegrin' | translate }}</option>
                    <option value="Moroccan">{{ 'header.moroccan' | translate }}</option>
                    <option value="Mozambican">{{ 'header.mozambican' | translate }}</option>
                    <option value="Namibian">{{ 'header.namibian' | translate }}</option>
                    <option value="Nepalese">{{ 'header.nepalese' | translate }}</option>
                    <option value="Nicaraguan">{{ 'header.nicaraguan' | translate }}</option>
                    <option value="Nigerien">{{ 'header.nigerien' | translate }}</option>
                    <option value="Nigerian">{{ 'header.nigerian' | translate }}</option>
                    <option value="Norwegian">{{ 'header.norwegian' | translate }}</option>
                    <option value="Pakistani">{{ 'header.pakistani' | translate }}</option>
                    <option value="Panamanian">{{ 'header.panamanian' | translate }}</option>
                    <option value="Paraguayan">{{ 'header.paraguayan' | translate }}</option>
                    <option value="Peruvian">{{ 'header.peruvian' | translate }}</option>
                    <option value="Filipino">{{ 'header.filipino' | translate }}</option>
                    <option value="Pole">{{ 'header.pole' | translate }}</option>
                    <option value="Portuguese">{{ 'header.portuguese' | translate }}</option>
                    <option value="Qatari">{{ 'header.qatari' | translate }}</option>
                    <option value="Romanian">{{ 'header.romanian' | translate }}</option>
                    <option value="Russian">{{ 'header.russian' | translate }}</option>
                    <option value="Rwandan">{{ 'header.rwandan' | translate }}</option>
                    <option value="Saudi">{{ 'header.saudi' | translate }}</option>
                    <option value="Scot">{{ 'header.scot' | translate }}</option>
                    <option value="Senegalese">{{ 'header.senegalese' | translate }}</option>
                    <option value="Serbian">{{ 'header.serbian' | translate }}</option>
                    <option value="Singaporean">{{ 'header.singaporean' | translate }}</option>
                    <option value="Slovak">{{ 'header.slovak' | translate }}</option>
                    <option value="Slovenian">{{ 'header.slovenian' | translate }}</option>
                    <option value="Somali">{{ 'header.somali' | translate }}</option>
                    <option value="Spaniard">{{ 'header.spaniard' | translate }}</option>
                    <option value="Sri-lankan">{{ 'header.sriLankan' | translate }}</option>
                    <option value="Sudanese">{{ 'header.sudanese' | translate }}</option>
                    <option value="Surinamese">{{ 'header.surinamese' | translate }}</option>
                    <option value="Swazi">{{ 'header.swazi' | translate }}</option>
                    <option value="Swede">{{ 'header.swede' | translate }}</option>
                    <option value="Swiss">{{ 'header.swiss' | translate }}</option>
                    <option value="Syrian">{{ 'header.syrian' | translate }}</option>
                    <option value="Taiwanese">{{ 'header.taiwanese' | translate }}</option>
                    <option value="Tadzhik">{{ 'header.tadzhik' | translate }}</option>
                    <option value="Tanzanian">{{ 'header.tanzanian' | translate }}</option>
                    <option value="Thai">{{ 'header.thai' | translate }}</option>
                    <option value="Togolese">{{ 'header.togolese' | translate }}</option>
                    <option value="Trinidadian">{{ 'header.trinidadian' | translate }}</option>
                    <option value="Tunisian">{{ 'header.tunisian' | translate }}</option>
                    <option value="Turk">{{ 'header.turk' | translate }}</option>
                    <option value="Ugandan">{{ 'header.ugandan' | translate }}</option>
                    <option value="Ukrainian">{{ 'header.ukrainian' | translate }}</option>
                    <option value="Kingdom">{{ 'header.kingdom' | translate }}</option>
                    <option value="United">{{ 'header.united' | translate }}</option>
                    <option value="American">{{ 'header.american' | translate }}</option>
                    <option value="Uruguayan">{{ 'header.uruguayan' | translate }}</option>
                    <option value="Uzbek">{{ 'header.uzbek' | translate }}</option>
                    <option value="Venezuelan">{{ 'header.venezuelan' | translate }}</option>
                    <option value="Vietnamese">{{ 'header.vietnamese' | translate }}</option>
                    <option value="Welshman">{{ 'header.welshman' | translate }}</option>
                    <option value="Yemeni">{{ 'header.yemeni' | translate }}</option>
                    <option value="Yugoslav">{{ 'header.yugoslav' | translate }}</option>
                    <option value="Zambian">{{ 'header.zambian' | translate }}</option>
                    <option value="Zimbabwean">{{ 'header.zimbabwean' | translate }}</option>
                  </select>
                  <label for="admission-nationality">{{ 'header.nationality' | translate }}<span style="color: #F44336;">*</span></label>
                </div>

                <div class="form-group">
                  <input (change)="changeEmail(mStudentEmail)" type="email" [(ngModel)]="mStudentEmail"
                    [ngModelOptions]="{standalone: true}" class="form-control" id="admission-student-email"
                    placeholder="{{ 'header.studentEmailPlaceholder' | translate }}">
                  <label for="admission-student-email">{{ 'header.studentEmail' | translate }}</label>
                </div>
                <div class="form-group contact-number-student">
                        <label for="admission-phone-number">{{ 'header.contactNumber' | translate }}</label>
                  <input type="text" placeholder="{{ 'header.mobileNumberForStaff' | translate }}" id="mobile-number" class="form-control"
                    [ngModelOptions]="{standalone: true}" [ngClass]="{
                      'input-field-registration-page': !invalidMobileNumber,
                      'input-field-registration-page-error': invalidMobileNumber
                    }" [disabled]="loader" #addStudentMobileNumber
                    (input)="handleDebounceMobileNumber(addStudentMobileNumber)" pattern="[0-9]*"
                    (keydown)="handleKeyDown($event)" autocomplete="off" [(ngModel)]="addStudentMobileNumberParsed" />
                </div>
                <div class="form-group">
                  <input [(ngModel)]="addNewStudentPENNumber" [ngModelOptions]="{standalone: true}"
                    class="form-control changePENNo" id="admission-pen-number" maxlength="12" type="text"
                    (keydown)="handleKeyDown($event)" placeholder="{{ 'header.pen' | translate }}">
                  <label for="admission-pen-number">{{ 'header.permanentEducationalNumberpen' | translate }} </label>
                </div>
                <div class="form-group">
                                    <label for="admission-aadhar-number">{{ brand.nationalIdFieldLabelKey | translate }}</label>
                  <input (keyup)="changeAadharNumber(mStudenAadharNumber)" [(ngModel)]="mStudenAadharNumber"
                    [ngModelOptions]="{standalone: true}" type="text" class="form-control"
                    id="admission-aadhar-number" maxlength="12" placeholder="{{ brand.nationalIdFieldLabelKey | translate }}">
                </div>

                <div class="form-group" *ngIf="houseNameList.length > 0">
                  <select id="admission-student-housename" name="admission-student-housename" class="form-control">
                    <option [value]="null">{{ 'header.none' | translate }}</option>
                    <option *ngFor="let house of houseNameList" [value]="house.houseName">{{house.houseName}}</option>
                  </select>
                  <label for="admission-student-housename">{{ 'header.houseName' | translate }}</label>
                </div>

                <div class="form-group">
                  <select [(ngModel)]="mCast" id="admission-cast" name="selectCaste" class="form-control">
                    <option value="">{{ 'header.selectCasteCategory' | translate }}</option>
                    <option value="General">{{ 'header.general' | translate }}</option>
                    <option value="OBC">{{ 'header.obc' | translate }}</option>
                    <option value="ST">{{ 'header.st' | translate }}</option>
                    <option value="SC">{{ 'header.sc' | translate }}</option>
                  </select>
                  <label for="admission-cast">{{ 'header.casteCategory' | translate }}</label>
                </div>

                <div class="form-group adv2-span-full">
                  <div class="input-check-box-container adv2-checkbox">
                    <input [(ngModel)]="addNewIsMinority" [ngModelOptions]="{standalone: true}"
                      class="check-box-input-filed" id="new-admission-minority" type="checkbox">
                    <label for="new-admission-minority" class="label-input-check-box adv2-minority-label">{{ 'header.minority' | translate }} </label>
                  </div>
                </div>
              </div>

            </div>
          </section>

          <!-- ============ STEP 2: Eligibility ============ -->
          <section class="adv2-panestep" [class.active]="currentStep === 2" [hidden]="currentStep !== 2">
            <div class="adv2-section-card">
              <h4 class="adv2-section-title">{{ 'header.whetherTheCandidateIs' | translate }}</h4>
              <p class="adv2-section-subtitle">{{ 'header.selectAnyThatApplyToStudent' | translate }}</p>

              <div class="adv2-grid adv2-grid-2">
                <div class="input-check-box-container adv2-checkbox">
                  <input class="check-box-input-filed" id="admission-specially-abled" type="checkbox"
                    [ngModelOptions]="{standalone: true}" [(ngModel)]="addNewStudentIsSpeciallyDisabled">
                  <label class="label-input-check-box adv2-eligibility-label">{{ 'header.speciallyAbledDivyangjan' | translate }} </label>
                </div>

                <div class="form-group image-container adv2-upload-group" *ngIf="addNewStudentIsSpeciallyDisabled">
                  <div class="adv2-upload-preview-row" [class.hide]="!newAddmissionStudentDivyangjanCopyName">
                    <img src="" id="new-addmission-student-Divyangjan-image-ele"
                      class="add-student-aadhar-image hide adv2-upload-thumb"
                      (click)="previewUploadedDocument('new-addmission-student-Divyangjan-copy', 'header.divyangjanCopy')">
                    <i class="ph-bold ph-file-pdf hide adv2-upload-pdf-icon" id="addmission-divyangjan-pdf-icon"
                      (click)="previewUploadedDocument('new-addmission-student-Divyangjan-copy', 'header.divyangjanCopy')"></i>
                    <span class="adv2-upload-filename">{{newAddmissionStudentDivyangjanCopyName}}</span>
                    <button type="button" class="adv2-upload-remove-btn"
                      (click)="removeUploadedDocument('new-addmission-student-Divyangjan-copy', '#new-addmission-student-Divyangjan-image-ele', 'addmission-divyangjan-pdf-icon', 'new-addmission-student-Divyangjan-copy-button'); newAddmissionStudentDivyangjanCopyName = null">
                      <i class="ph-bold ph-x"></i>
                    </button>
                  </div>
                  <button id="new-addmission-student-Divyangjan-copy-button" [class.hide]="newAddmissionStudentDivyangjanCopyName"
                    (click)="openNewStudentDivyangjanCopyUpload()"
                    class="btn-raised ink-reaction form-control upload-button adv2-upload-btn" type="button">
                    <span class="adv2-upload-icon"><i class="ph-bold ph-upload-simple"></i></span>
                    <span class="adv2-upload-text">
                      <span class="adv2-upload-title">{{ 'header.uploadFile' | translate }}</span>
                      <span class="adv2-upload-hint">{{ 'header.pdfJpgMaxSize' | translate }}</span>
                    </span>
                  </button>
                  <input (change)="newAddmissionStudentDivyangjanCopyName = $event.target.files[0]?.name; startUploadingNewDivyangjanCopy()"
                    type="file" class="form-control hide image-input" id="new-addmission-student-Divyangjan-copy">
                  <label for="admission-phone-number">{{ 'header.divyangjanCopy' | translate }}</label>
                </div>
              </div>

              <div class="adv2-grid adv2-grid-2" *ngIf="mGenderGroup === '0'">
                <div class="input-check-box-container adv2-checkbox">
                  <input class="check-box-input-filed" id="admission-single-girl-child" type="checkbox"
                    [ngModelOptions]="{standalone: true}" [(ngModel)]="addNewStudentIsSingleGirlChild">
                  <label for="admission-single-girl-child" class="label-input-check-box adv2-eligibility-label">{{ 'header.singleGirlChild' | translate }}
                  </label>
                </div>

                <div class="form-group image-container adv2-upload-group" *ngIf="addNewStudentIsSingleGirlChild">
                  <div class="adv2-upload-preview-row" [class.hide]="!newAddmissionStudentSingleGirlCopyName">
                    <img src="" id="new-addmission-student-single-girl-image-ele"
                      class="add-student-aadhar-image hide adv2-upload-thumb"
                      (click)="previewUploadedDocument('new-addmission-student-single-girl-copy', 'header.singleGirlChildCopy')">
                    <i class="ph-bold ph-file-pdf hide adv2-upload-pdf-icon" id="addmission-single-girl-pdf-icon"
                      (click)="previewUploadedDocument('new-addmission-student-single-girl-copy', 'header.singleGirlChildCopy')"></i>
                    <span class="adv2-upload-filename">{{newAddmissionStudentSingleGirlCopyName}}</span>
                    <button type="button" class="adv2-upload-remove-btn"
                      (click)="removeUploadedDocument('new-addmission-student-single-girl-copy', '#new-addmission-student-single-girl-image-ele', 'addmission-single-girl-pdf-icon', 'new-addmission-student-single-girl-copy-button'); newAddmissionStudentSingleGirlCopyName = null">
                      <i class="ph-bold ph-x"></i>
                    </button>
                  </div>
                  <button id="new-addmission-student-single-girl-copy-button" [class.hide]="newAddmissionStudentSingleGirlCopyName"
                    (click)="openNewStudentSingleGirlCopyUpload()"
                    class="btn-raised ink-reaction form-control upload-button adv2-upload-btn" type="button">
                    <span class="adv2-upload-icon"><i class="ph-bold ph-upload-simple"></i></span>
                    <span class="adv2-upload-text">
                      <span class="adv2-upload-title">{{ 'header.uploadFile' | translate }}</span>
                      <span class="adv2-upload-hint">{{ 'header.pdfJpgMaxSize' | translate }}</span>
                    </span>
                  </button>
                  <input (change)="newAddmissionStudentSingleGirlCopyName = $event.target.files[0]?.name; startUploadingNewSingleGirlCopy()"
                    type="file" class="form-control hide image-input" id="new-addmission-student-single-girl-copy">
                  <label for="admission-phone-number">{{ 'header.singleGirlChildCopy' | translate }}</label>
                </div>
              </div>

              <div class="adv2-grid adv2-grid-2" *ngIf="mCast === 'General'">
                <div class="input-check-box-container adv2-checkbox">
                  <input class="check-box-input-filed" id="admission-ews" type="checkbox"
                    [ngModelOptions]="{standalone: true}" [(ngModel)]="addNewStudentIsEWS">
                  <label for="admission-ews" class="label-input-check-box adv2-eligibility-label">{{ 'header.belongingToEwsEconomically' | translate }}
                    {{ 'header.weaker' | translate }}
                    {{ 'header.section' | translate }}) </label>
                </div>

                <div class="form-group image-container adv2-upload-group" *ngIf="addNewStudentIsEWS">
                  <div class="adv2-upload-preview-row" [class.hide]="!newAddmissionStudentEWSCopyName">
                    <img src="" id="new-addmission-student-EWS-image-ele"
                      class="add-student-aadhar-image hide adv2-upload-thumb"
                      (click)="previewUploadedDocument('new-addmission-student-EWS-copy', 'header.ewsCopy')">
                    <i class="ph-bold ph-file-pdf hide adv2-upload-pdf-icon" id="addmission-EWS-pdf-icon"
                      (click)="previewUploadedDocument('new-addmission-student-EWS-copy', 'header.ewsCopy')"></i>
                    <span class="adv2-upload-filename">{{newAddmissionStudentEWSCopyName}}</span>
                    <button type="button" class="adv2-upload-remove-btn"
                      (click)="removeUploadedDocument('new-addmission-student-EWS-copy', '#new-addmission-student-EWS-image-ele', 'addmission-EWS-pdf-icon', 'new-addmission-student-EWS-copy-button'); newAddmissionStudentEWSCopyName = null">
                      <i class="ph-bold ph-x"></i>
                    </button>
                  </div>
                  <button id="new-addmission-student-EWS-copy-button" [class.hide]="newAddmissionStudentEWSCopyName" (click)="openNewStudentEWSCopyUpload()"
                    class="btn-raised ink-reaction form-control upload-button adv2-upload-btn" type="button">
                    <span class="adv2-upload-icon"><i class="ph-bold ph-upload-simple"></i></span>
                    <span class="adv2-upload-text">
                      <span class="adv2-upload-title">{{ 'header.uploadFile' | translate }}</span>
                      <span class="adv2-upload-hint">{{ 'header.pdfJpgMaxSize' | translate }}</span>
                    </span>
                  </button>
                  <input (change)="newAddmissionStudentEWSCopyName = $event.target.files[0]?.name; startUploadingNewEWSCopy()"
                    type="file" class="form-control hide image-input"
                    id="new-addmission-student-EWS-copy">
                  <label for="admission-phone-number">{{ 'header.ewsCopy' | translate }}</label>
                </div>
              </div>
            </div>
          </section>

          <!-- ============ STEP 3: Admission Details ============ -->
          <section class="adv2-panestep" [class.active]="currentStep === 3" [hidden]="currentStep !== 3">
            <div class="adv2-section-card">
              <h4 class="adv2-section-title">{{ 'header.admissionDetails' | translate }}</h4>
              <p class="adv2-section-subtitle">{{ 'header.academicAndEnrolmentInformation' | translate }}</p>
              <div class="adv2-grid adv2-grid-3">
                <div class="form-group">
                  <select (change)="changeAcademic(selectedAcademicYear)" id="select-academic-year"
                    [(ngModel)]="selectedAcademicYear" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateSelectedAcademic($event)" name="select1" class="form-control">
                    <option value="0">{{ 'header.selectAcademicYear' | translate }}</option>
                    <option *ngFor="let o of academicYearsList" [value]="o.pkAcademicId">{{o.Year}}</option>
                  </select>
                  <label for="select-academic-year">{{ 'header.selectAcademicYear' | translate }}<span style="color: #F44336;">*</span></label>
                </div>
                <div class="form-group">
                  <select [(ngModel)]="admissionBase" [ngModelOptions]="{standalone: true}" id="admission-base"
                    name="select1" class="form-control">
                    <option value="written">{{ 'header.writtenExam' | translate }}</option>
                    <option value="interview">{{ 'header.interview' | translate }}</option>
                  </select>
                  <label for="admission-base">{{ 'header.admissionBase' | translate }}<span style="color: #F44336;">*</span></label>
                </div>
                <div class="form-group">
                  <select [(ngModel)]="mAdmissionStream" [ngModelOptions]="{standalone: true}" id="admission-stream"
                    name="select1" class="form-control">
                    <option value="general">{{ 'header.generalDefault' | translate }}</option>
                    <option *ngFor="let o of studentCategoryListForAdmission" [value]="o.pkStudentsCategoryId">
                      {{o.Name}}</option>
                  </select>
                  <label for="admission-stream">{{ 'header.feesCategory' | translate }}<span style="color: #F44336;">*</span></label>
                </div>
                <div class="form-group">
                  <select (change)="changeCategory(selectedCategory)" id="admission-select-category"
                    [(ngModel)]="selectedCategory" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateSelectedCategory($event)" name="select1" class="form-control">
                    <option value="0">{{ 'header.selectCategory' | translate }}</option>
                    <option *ngFor="let o of categoryList" [value]="o.categoryId">{{o.categoryName}}</option>
                  </select>
                  <label for="admission-select-category">{{ 'header.selectClassCategory' | translate }}<span
                      style="color: #F44336;">*</span></label>
                </div>
                <div class="form-group">
                  <select (change)="changeClass(selectedClassSection)" id="add-classname"
                    [(ngModel)]="selectedClassSection" (ngModelChange)="updateSelectedClassSection($event)"
                    name="select1" class="form-control">
                    <option value="0">{{ 'header.selectClass' | translate }}</option>
                    <option *ngFor="let o of classSectionList" [value]="o.classid">{{o.classname}}</option>
                  </select>
                  <label for="add-classname">{{ 'header.selectClass' | translate }}<span style="color: #F44336;">*</span></label>
                </div>
                <div class="form-group">
                  <select (change)="changeClassSection(selectedClassSectionId)" id="add-clname"
                    [(ngModel)]="selectedClassSectionId" (ngModelChange)="updateSelectedClassSectionId($event)"
                    name="select1" class="form-control">
                    <option value="0">{{ 'header.selectSection' | translate }}</option>
                    <option *ngFor="let o of classSections" [value]="o.claaSectionId">{{o.classSection}}</option>
                  </select>
                  <label for="add-clname">{{ 'header.selectClassSection' | translate }}<span style="color: #F44336;">*</span></label>
                </div>

                <div class="form-group" *ngIf="generateStudentRegistrationId == 'MANUAL'">
                  <input [(ngModel)]="mAdmissionNumber" [ngModelOptions]="{standalone: true}" type="text"
                    class="form-control" id="regular2" placeholder="{{ 'header.admissionNumber' | translate }}">
                  <label for="regular2">{{ 'header.admissionNumber' | translate }}<span style="color: #F44336;">*</span><span style="font-size: 10px;"
                      class="last_registration_number"></span></label>
                </div>
                <div class="form-group contact-number-student">
                  <p-calendar [(ngModel)]="mAdmissionDateDate" [ngModelOptions]="{standalone: true}" inputId="admission-v2-date"
                    styleClass="adv2-calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                    appendTo="body" (onSelect)="changeAdmissionDate($event)" placeholder="{{ 'header.ddmmyyyy' | translate }}"></p-calendar>
                  <label for="admission-v2-date">{{ 'header.admissionDate' | translate }}<span style="color: #F44336;">* </span> ({{ 'header.ddmmyyyy' | translate }}
                    )</label>
                </div>
              </div>

              <!-- Transport -->
              <div class="adv2-subsection" *ngIf="busStopListData.length>0">
                <h4 class="adv2-section-title adv2-subsection-title">{{ 'header.selectTransportOptions' | translate }}</h4>
                <div class="adv2-grid adv2-grid-2">
                  <div class="form-group">
                    <select id="bus-stop-selection-add" (change)="addStd_updateSelectedBusRoute($event.target.value)"
                      name="select1" class="form-control">
                      <option [value]="0">{{ 'header.notAssigned' | translate }}</option>
                      <option *ngFor="let o of busStopListData" [value]="o.PkBusStopId">{{o.BusStopName}}</option>
                    </select>
                    <label for="bus-stop-selection-add">{{ 'header.selectStop' | translate }}</label>
                  </div>

                  <div class="form-group">
                    <select id="bus-selection-add" name="select1" class="form-control">
                      <option [value]="0">{{ 'header.notAssigned' | translate }}</option>
                      <option *ngFor="let o of busListData" [value]="o.pkBusId">
                        {{o.BusName}}-{{o.BusNumber}}-{{o.RouteName}}({{o.startStop}} {{ 'header.to' | translate }}
                        {{o.endStop}})-(Capacity-{{o.Capacity}})-(Filled-{{o.assignedStudents}})</option>
                    </select>
                    <label for="bus-selection-add">{{ 'header.selectBus' | translate }}</label>
                  </div>

                  <div class="form-group">
                    <input [(ngModel)]="mTotalBusFees" [ngModelOptions]="{standalone: true}" type="text"
                      class="form-control adv2-fare-input" id="regular1" disabled="disabled">
                    <label for="regular1">{{ 'header.fare' | translate }}({{currType}})</label>
                  </div>

                  <div *ngIf="isTermsVisible" id="select_busterm_layout" class="adv2-bus-terms animated fadeInUp">
                    <h5>{{ 'header.selectTerms' | translate }}</h5>
                    <label class="checkbox-inline checkbox-styled">
                      <input type="checkbox" (change)="onBusTermChangedSelectAll($event)"><span>{{ 'header.selectAllTerms' | translate }} </span>
                    </label>
                    <div>
                      <label *ngFor="let term of avalialableTermsList" class="checkbox-inline checkbox-styled">
                        <input type="checkbox" [checked]="term.isSelectedTerm" value="{{term.pkBusStopTermId}}"
                          (change)="onBusTermChanged($event,term.pkBusStopTermId)"><span>{{term.termName}} ({{ 'header.dueDate' | translate }}:
                          {{term.termDueDate | date}})</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- ============ STEP 4: Family ============ -->
          <section class="adv2-panestep" [class.active]="currentStep === 4" [hidden]="currentStep !== 4">
            <div class="adv2-section-card">
              <h4 class="adv2-section-title">{{ 'header.fathersDetails' | translate }}</h4>
              <div class="adv2-family-photo-row">
                <div class="adv2-family-photo-box">
                  <img *ngIf="fatherImagePreview" [src]="fatherImagePreview" class="adv2-family-photo-img" />
                  <i *ngIf="!fatherImagePreview" class="ph-bold ph-user adv2-family-photo-placeholder"></i>
                  <button type="button" class="adv2-family-photo-camera-badge" (click)="triggerFamilyImageUpload('father-image-input')">
                    <i class="ph-bold ph-camera"></i>
                  </button>
                </div>
                <input type="file" id="father-image-input" accept="image/*" class="hide"
                  (change)="onFamilyImageSelected($event, 'father')" />
                <div class="adv2-family-photo-info">
                  <h5 class="adv2-family-photo-title">{{ 'header.fathersPhoto' | translate }}</h5>
                  <p class="adv2-family-photo-helper">{{ 'header.photoUploadHelperText' | translate }}</p>
                  <div class="adv2-family-photo-actions">
                    <button type="button" class="adv2-family-photo-btn" (click)="triggerFamilyImageUpload('father-image-input')">
                      <i class="ph-bold ph-upload-simple"></i> {{ 'header.uploadPhoto' | translate }}
                    </button>
                    <button type="button" class="adv2-family-photo-remove" *ngIf="fatherImagePreview"
                      (click)="removeFamilyImage('father')">
                      <i class="ph-bold ph-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="adv2-grid adv2-grid-3">
                <div class="form-group">
                  <input (change)="changeFatherName(mFatherName)" [(ngModel)]="mFatherName"
                    [ngModelOptions]="{standalone: true}" type="text" class="form-control"
                    id="admission-father-name" maxlength="100" placeholder="{{ 'header.fullName' | translate }}">
                  <label for="admission-father-name">{{ 'header.fathersName' | translate }}<span style="color: #F44336;">*</span></label>
                </div>
                <div class="form-group contact-number-student">
                  <input type="text" placeholder="{{ 'header.enterContactNumber' | translate }}" id="add-father-mobile-number"
                    [ngModelOptions]="{standalone: true}" class="form-control changeMobNo" [ngClass]="{
                      'input-field-registration-page': !invalidAddStudentFatherMobileNumber,
                      'input-field-registration-page-error': invalidAddStudentFatherMobileNumber
                    }" #addFatherMobileNumber
                    (input)="addStudentMobileFatherNumberValidator(addFatherMobileNumber)"
                    (keydown)="handleKeyDown($event)" autocomplete="off"
                    [(ngModel)]="addStudentFatherMobileNumberInput" maxlength="20" />
                  <label for="admission-fMob">{{ 'header.contactNumber' | translate }}<span style="color: #F44336;">*</span></label>
                </div>
                <div class="form-group contact-number-student">
                  <input type="text" placeholder="{{ 'header.enterAlternateMobileNumber' | translate }}" id="add-father-alt-mobile-number"
                    [ngModelOptions]="{standalone: true}" class="form-control changeMobNo" [ngClass]="{
                      'input-field-registration-page': !invalidAddFatherAltMobileNumber,
                      'input-field-registration-page-error': invalidAddFatherAltMobileNumber
                    }" #addFatherAltMobileNumber
                    (input)="handleDebounceAddFatherAltMobileNumber(addFatherAltMobileNumber)"
                    (keydown)="handleKeyDown($event)" autocomplete="off"
                    [(ngModel)]="addFatherAltMobileNumberInput" maxlength="20" />
                  <label for="add-father-alt-mobile-number">{{ 'header.alternateMobileNumber' | translate }}</label>
                </div>
                <div class="form-group contact-number-student whatsapp-number-field">
                  <input type="text" placeholder="{{ 'header.enterWhatsappNumber' | translate }}" id="add-father-whatsapp-number"
                    [ngModelOptions]="{standalone: true}" class="form-control changeMobNo" [ngClass]="{
                      'input-field-registration-page': !invalidAddFatherWhatsappNumber,
                      'input-field-registration-page-error': invalidAddFatherWhatsappNumber
                    }" #addFatherWhatsappNumber
                    (input)="handleDebounceAddFatherWhatsappNumber(addFatherWhatsappNumber)"
                    (keydown)="handleKeyDown($event)" autocomplete="off"
                    [(ngModel)]="addFatherWhatsappNumberInput" maxlength="20" />
                  <label for="add-father-whatsapp-number"><i class="fa fa-whatsapp"></i> {{ 'header.whatsappNumber' | translate }}</label>
                </div>
                <div class="form-group">
                  <select [(ngModel)]="mFatherOccupation" [ngModelOptions]="{standalone: true}"
                    id="admission-father-occupation" name="select1" class="form-control">
                    <option value="0">{{ 'selectOccupation' | translate }}</option>
                    <option value="Agriculture, Food and Natural Resources">{{ 'header.agricultureFoodAndNaturalResources' | translate }}
                    </option>
                    <option value="Architecture and Construction">{{ 'header.architectureAndConstruction' | translate }}</option>
                    <option value="Arts, Audio/Video Technology and Communications">{{ 'header.artsAudiovideoTechnologyAnd' | translate }}
                      {{ 'header.communications' | translate }}</option>
                    <option value="Business Management and Administration">{{ 'header.businessManagementAndAdministration' | translate }}
                    </option>
                    <option value="Education and Training">{{ 'header.educationAndTraining' | translate }}</option>
                    <option value="Finance">{{ 'header.finance' | translate }}</option>
                    <option value="Government and Public Administration">{{ 'header.governmentAndPublicAdministration' | translate }}
                    </option>
                    <option value="Health Science">{{ 'header.healthScience' | translate }}</option>
                    <option value="Hospitality and Tourism">{{ 'header.hospitalityAndTourism' | translate }}</option>
                    <option value="Human Services">{{ 'header.humanServices' | translate }}</option>
                    <option value="Information Technology">{{ 'header.informationTechnology' | translate }}</option>
                    <option value="Law, Public Safety, Corrections and Security">{{ 'header.lawPublicSafetyCorrectionsAnd' | translate }}
                      {{ 'header.security' | translate }}</option>
                    <option value="Manufacturing">{{ 'header.manufacturing' | translate }}</option>
                    <option value="Marketing, Sales and Service">{{ 'header.marketingSalesAndService' | translate }}</option>
                    <option value="Science, Technology, Engineering and Mathematics">{{ 'header.scienceTechnology' | translate }}
                      {{ 'header.engineeringAndMathematics' | translate }}</option>
                    <option value="Transportation, Distribution and Logistics">{{ 'header.transportationDistributionAnd' | translate }}
                      {{ 'header.logistics' | translate }}</option>
                    <option value="Others">{{ 'header.others' | translate }}</option>
                  </select>
                  <label for="admission-father-occupation">{{ 'header.occupation' | translate }}</label>
                </div>
                <div class="form-group">
                  <input (change)="changeFatherQual(mFatherQualification)" [(ngModel)]="mFatherQualification"
                    [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="admission-edu"
                    placeholder="{{ 'header.qualification' | translate }}">
                  <label for="admission-edu">{{ 'header.educationalQualification' | translate }}</label>
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" id="father-annual-income"
                    [(ngModel)]="addNewStudentFatherAnnualIncome" [ngModelOptions]="{standalone: true}"
                    (keydown)="handleKeyDown($event)" placeholder="{{ 'header.amount' | translate }}">
                  <label for="regular2">{{ 'header.annualIncome' | translate }}</label>
                </div>
                <div class="form-group">
                  <input [(ngModel)]="addNewFatherPinCode" [ngModelOptions]="{standalone: true}"
                    class="form-control" id="admission-pincode" maxlength="6" type="text"
                    (keydown)="handleKeyDown($event)" placeholder="{{ 'header.pincode' | translate }}">
                  <label for="admission-pincode">{{ 'header.pinCode' | translate }} </label>
                </div>
                <div class="form-group">
                  <input (change)="changeFatherEmail(mFatherEmail)" type="email" [(ngModel)]="mFatherEmail"
                    [ngModelOptions]="{standalone: true}" class="form-control" id="admission-father-email"
                    placeholder="{{ 'header.emailPlaceholder' | translate }}">
                  <label for="admission-father-email">{{ 'header.fatherEmail' | translate }}</label>
                </div>
                <div class="form-group adv2-span-full">
                  <textarea (change)="changeFatherAdd(mFatherAddress)" [(ngModel)]="mFatherAddress"
                    [ngModelOptions]="{standalone: true}" name="textarea1" id="admission-staddress"
                    class="form-control" rows="3" placeholder="{{ 'header.address' | translate }}"></textarea>
                  <label for="admission-staddress">{{ 'header.contactAddress' | translate }}<span style="color: #F44336;">*</span></label>
                </div>
              </div>

              <h4 class="adv2-section-title adv2-subsection-title adv2-no-divider">{{ 'header.mothersDetails' | translate }}</h4>
              <div class="adv2-family-photo-row">
                <div class="adv2-family-photo-box">
                  <img *ngIf="motherImagePreview" [src]="motherImagePreview" class="adv2-family-photo-img" />
                  <i *ngIf="!motherImagePreview" class="ph-bold ph-user adv2-family-photo-placeholder"></i>
                  <button type="button" class="adv2-family-photo-camera-badge" (click)="triggerFamilyImageUpload('mother-image-input')">
                    <i class="ph-bold ph-camera"></i>
                  </button>
                </div>
                <input type="file" id="mother-image-input" accept="image/*" class="hide"
                  (change)="onFamilyImageSelected($event, 'mother')" />
                <div class="adv2-family-photo-info">
                  <h5 class="adv2-family-photo-title">{{ 'header.mothersPhoto' | translate }}</h5>
                  <p class="adv2-family-photo-helper">{{ 'header.photoUploadHelperText' | translate }}</p>
                  <div class="adv2-family-photo-actions">
                    <button type="button" class="adv2-family-photo-btn" (click)="triggerFamilyImageUpload('mother-image-input')">
                      <i class="ph-bold ph-upload-simple"></i> {{ 'header.uploadPhoto' | translate }}
                    </button>
                    <button type="button" class="adv2-family-photo-remove" *ngIf="motherImagePreview"
                      (click)="removeFamilyImage('mother')">
                      <i class="ph-bold ph-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="adv2-grid adv2-grid-3">
                <div class="form-group">
                  <input (change)="changeMotherName(mMotherName)" [(ngModel)]="mMotherName"
                    [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="motherName"
                    maxlength="100" placeholder="{{ 'header.fullName' | translate }}">
                  <label for="motherName">{{ 'header.mothersName' | translate }}</label>
                </div>
                <div class="form-group contact-number-student">
                  <input type="text" placeholder="{{ 'header.enterContactNumber' | translate }}" id="add-student-mother-mobile-number"
                    [ngModelOptions]="{standalone: true}" class="form-control" [ngClass]="{
                      'input-field-registration-page': !invalidAddStudentMotherMobileNumber,
                      'input-field-registration-page-error': invalidAddStudentMotherMobileNumber
                    }" #addStudentMotherMobileNumber
                    (input)="handleDebounceAddStudentMotherMobileNumber(addStudentMotherMobileNumber)"
                    (keydown)="handleKeyDown($event)" autocomplete="off"
                    [(ngModel)]="addNewStudentMotherNumberInput" maxlength="20" />
                  <label for="motherMob">{{ 'header.contactNumber' | translate }}</label>
                </div>
                <div class="form-group contact-number-student">
                  <input type="text" placeholder="{{ 'header.enterAlternateMobileNumber' | translate }}" id="add-mother-alt-mobile-number"
                    [ngModelOptions]="{standalone: true}" class="form-control changeMobNo" [ngClass]="{
                      'input-field-registration-page': !invalidAddMotherAltMobileNumber,
                      'input-field-registration-page-error': invalidAddMotherAltMobileNumber
                    }" #addMotherAltMobileNumber
                    (input)="handleDebounceAddMotherAltMobileNumber(addMotherAltMobileNumber)"
                    (keydown)="handleKeyDown($event)" autocomplete="off"
                    [(ngModel)]="addMotherAltMobileNumberInput" maxlength="20" />
                  <label for="add-mother-alt-mobile-number">{{ 'header.alternateMobileNumber' | translate }}</label>
                </div>
                <div class="form-group contact-number-student whatsapp-number-field">
                  <input type="text" placeholder="{{ 'header.enterWhatsappNumber' | translate }}" id="add-mother-whatsapp-number"
                    [ngModelOptions]="{standalone: true}" class="form-control changeMobNo" [ngClass]="{
                      'input-field-registration-page': !invalidAddMotherWhatsappNumber,
                      'input-field-registration-page-error': invalidAddMotherWhatsappNumber
                    }" #addMotherWhatsappNumber
                    (input)="handleDebounceAddMotherWhatsappNumber(addMotherWhatsappNumber)"
                    (keydown)="handleKeyDown($event)" autocomplete="off"
                    [(ngModel)]="addMotherWhatsappNumberInput" maxlength="20" />
                  <label for="add-mother-whatsapp-number"><i class="fa fa-whatsapp"></i> {{ 'header.whatsappNumber' | translate }}</label>
                </div>
                <div class="form-group">
                  <select id="admission-mother-occupation" name="select1" class="form-control">
                    <option value="0">{{ 'selectOccupation' | translate }}</option>
                    <option value="Agriculture, Food and Natural Resources">{{ 'header.agricultureFoodAndNaturalResources' | translate }}
                    </option>
                    <option value="Architecture and Construction">{{ 'header.architectureAndConstruction' | translate }}</option>
                    <option value="Arts, Audio/Video Technology and Communications">{{ 'header.artsAudiovideoTechnologyAnd' | translate }}
                      {{ 'header.communications' | translate }}</option>
                    <option value="Business Management and Administration">{{ 'header.businessManagementAndAdministration' | translate }}
                    </option>
                    <option value="Education and Training">{{ 'header.educationAndTraining' | translate }}</option>
                    <option value="Finance">{{ 'header.finance' | translate }}</option>
                    <option value="Government and Public Administration">{{ 'header.governmentAndPublicAdministration' | translate }}
                    </option>
                    <option value="Health Science">{{ 'header.healthScience' | translate }}</option>
                    <option value="Hospitality and Tourism">{{ 'header.hospitalityAndTourism' | translate }}</option>
                    <option value="Human Services">{{ 'header.humanServices' | translate }}</option>
                    <option value="Information Technology">{{ 'header.informationTechnology' | translate }}</option>
                    <option value="Law, Public Safety, Corrections and Security">{{ 'header.lawPublicSafetyCorrectionsAnd' | translate }}
                      {{ 'header.security' | translate }}</option>
                    <option value="Manufacturing">{{ 'header.manufacturing' | translate }}</option>
                    <option value="Marketing, Sales and Service">{{ 'header.marketingSalesAndService' | translate }}</option>
                    <option value="Science, Technology, Engineering and Mathematics">{{ 'header.scienceTechnology' | translate }}
                      {{ 'header.engineeringAndMathematics' | translate }}</option>
                    <option value="Transportation, Distribution and Logistics">{{ 'header.transportationDistributionAnd' | translate }}
                      {{ 'header.logistics' | translate }}</option>
                    <option value="Others">{{ 'header.others' | translate }}</option>
                  </select>
                  <label for="admission-mother-occupation">{{ 'header.occupation' | translate }}</label>
                </div>
                <div class="form-group">
                  <input [(ngModel)]="mMotherQualification" [ngModelOptions]="{standalone: true}" type="text"
                    class="form-control" id="motherQual" placeholder="{{ 'header.qualification' | translate }}">
                  <label for="motherQual">{{ 'header.educationalQualification' | translate }}</label>
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" id="mother-annual-income"
                    [ngModelOptions]="{standalone: true}" [(ngModel)]="addNewStudentMotherAnnualIncome"
                    (keydown)="handleKeyDown($event)" placeholder="{{ 'header.amount' | translate }}">
                  <label for="regular2">{{ 'header.annualIncome' | translate }}</label>
                </div>
                <div class="form-group">
                  <input [(ngModel)]="addNewMotherPinCode" [ngModelOptions]="{standalone: true}"
                    class="form-control" id="mother-pincode" maxlength="6" type="text"
                    (keydown)="handleKeyDown($event)" placeholder="{{ 'header.pincode' | translate }}">
                  <label for="mother-pincode">{{ 'header.pinCode' | translate }} </label>
                </div>
                <div class="form-group">
                  <input (change)="changeMotherEmail(mMotherEmail)" type="email" [(ngModel)]="mMotherEmail"
                    [ngModelOptions]="{standalone: true}" class="form-control" id="admission-mother-email"
                    placeholder="{{ 'header.emailPlaceholder' | translate }}">
                  <label for="admission-mother-email">{{ 'header.motherEmail' | translate }}</label>
                </div>
                <div class="form-group adv2-span-full">
                  <div class="checkbox checkbox-styled">
                    <label>
                      <input [(ngModel)]="mMotherSameFatherAddress" [ngModelOptions]="{standalone: true}"
                        type="checkbox" value="" (change)="mMotherSameFatherAddressClick()">
                      <span>{{ 'header.useFathersAddressPinCodeAndMobileNumber' | translate }}</span>
                    </label>
                  </div>
                </div>
                <div class="form-group adv2-span-full">
                  <textarea [(ngModel)]="mMotherAddress" [ngModelOptions]="{standalone: true}" name="textarea1"
                    id="mother-staddress" class="form-control" rows="3" placeholder="{{ 'header.address' | translate }}">{{mMotherAddress}}</textarea>
                  <label for="mother-staddress">{{ 'header.contactAddress' | translate }}</label>
                </div>
              </div>

              <h4 class="adv2-section-title adv2-subsection-title adv2-no-divider">{{ 'header.guardiansDetails' | translate }}</h4>
              <div class="adv2-family-photo-row">
                <div class="adv2-family-photo-box">
                  <img *ngIf="guardianImagePreview" [src]="guardianImagePreview" class="adv2-family-photo-img" />
                  <i *ngIf="!guardianImagePreview" class="ph-bold ph-user adv2-family-photo-placeholder"></i>
                  <button type="button" class="adv2-family-photo-camera-badge" (click)="triggerFamilyImageUpload('guardian-image-input')">
                    <i class="ph-bold ph-camera"></i>
                  </button>
                </div>
                <input type="file" id="guardian-image-input" accept="image/*" class="hide"
                  (change)="onFamilyImageSelected($event, 'guardian')" />
                <div class="adv2-family-photo-info">
                  <h5 class="adv2-family-photo-title">{{ 'header.guardiansPhoto' | translate }}</h5>
                  <p class="adv2-family-photo-helper">{{ 'header.photoUploadHelperText' | translate }}</p>
                  <div class="adv2-family-photo-actions">
                    <button type="button" class="adv2-family-photo-btn" (click)="triggerFamilyImageUpload('guardian-image-input')">
                      <i class="ph-bold ph-upload-simple"></i> {{ 'header.uploadPhoto' | translate }}
                    </button>
                    <button type="button" class="adv2-family-photo-remove" *ngIf="guardianImagePreview"
                      (click)="removeFamilyImage('guardian')">
                      <i class="ph-bold ph-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="adv2-grid adv2-grid-3">
                <div class="form-group">
                  <input (change)="changeGuarName(mGuardianName)" [(ngModel)]="mGuardianName"
                    [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="guardian-name"
                    placeholder="{{ 'header.fullName' | translate }}">
                  <label for="guardian-name">{{ 'header.guardiansName' | translate }}<span style="color: #F44336;"></span></label>
                </div>
                <div class="form-group contact-number-student">
                  <input type="text" placeholder="{{ 'header.enterContactNumber' | translate }}"
                    id="add-student-guardian-mobile-number-admission" [ngModelOptions]="{standalone: true}"
                    class="form-control" [ngClass]="{
                      'add-student-contact-field': !invalidAddStudentGuardianMobileNumber,
                      'add-student-contact-field-error': invalidAddStudentGuardianMobileNumber
                    }" #addStudentGuardianMobileNumber
                    (input)="handleDebounceAddStudentGuardianMobileNumber(addStudentGuardianMobileNumber)"
                    (keydown)="handleKeyDown($event)" autocomplete="off"
                    [(ngModel)]="addNewStudentGuardianNumberInput" maxlength="20" />
                  <label for="guardian-number">{{ 'header.contactNumber' | translate }}<span style="color: #F44336;"></span></label>
                </div>
                <div class="form-group contact-number-student">
                  <input type="text" placeholder="{{ 'header.enterAlternateMobileNumber' | translate }}" id="add-guardian-alt-mobile-number"
                    [ngModelOptions]="{standalone: true}" class="form-control changeMobNo" [ngClass]="{
                      'input-field-registration-page': !invalidAddGuardianAltMobileNumber,
                      'input-field-registration-page-error': invalidAddGuardianAltMobileNumber
                    }" #addGuardianAltMobileNumber
                    (input)="handleDebounceAddGuardianAltMobileNumber(addGuardianAltMobileNumber)"
                    (keydown)="handleKeyDown($event)" autocomplete="off"
                    [(ngModel)]="addGuardianAltMobileNumberInput" maxlength="20" />
                  <label for="add-guardian-alt-mobile-number">{{ 'header.alternateMobileNumber' | translate }}</label>
                </div>
                <div class="form-group contact-number-student whatsapp-number-field">
                  <input type="text" placeholder="{{ 'header.enterWhatsappNumber' | translate }}" id="add-guardian-whatsapp-number"
                    [ngModelOptions]="{standalone: true}" class="form-control changeMobNo" [ngClass]="{
                      'input-field-registration-page': !invalidAddGuardianWhatsappNumber,
                      'input-field-registration-page-error': invalidAddGuardianWhatsappNumber
                    }" #addGuardianWhatsappNumber
                    (input)="handleDebounceAddGuardianWhatsappNumber(addGuardianWhatsappNumber)"
                    (keydown)="handleKeyDown($event)" autocomplete="off"
                    [(ngModel)]="addGuardianWhatsappNumberInput" maxlength="20" />
                  <label for="add-guardian-whatsapp-number"><i class="fa fa-whatsapp"></i> {{ 'header.whatsappNumber' | translate }}</label>
                </div>
                <div class="form-group">
                  <select id="admission-guardian-occupation" name="select1" class="form-control">
                    <option value="0">{{ 'selectOccupation' | translate }}</option>
                    <option value="Agriculture, Food and Natural Resources">{{ 'header.agricultureFoodAndNaturalResources' | translate }}
                    </option>
                    <option value="Architecture and Construction">{{ 'header.architectureAndConstruction' | translate }}</option>
                    <option value="Arts, Audio/Video Technology and Communications">{{ 'header.artsAudiovideoTechnologyAnd' | translate }}
                      {{ 'header.communications' | translate }}</option>
                    <option value="Business Management and Administration">{{ 'header.businessManagementAndAdministration' | translate }}
                    </option>
                    <option value="Education and Training">{{ 'header.educationAndTraining' | translate }}</option>
                    <option value="Finance">{{ 'header.finance' | translate }}</option>
                    <option value="Government and Public Administration">{{ 'header.governmentAndPublicAdministration' | translate }}
                    </option>
                    <option value="Health Science">{{ 'header.healthScience' | translate }}</option>
                    <option value="Hospitality and Tourism">{{ 'header.hospitalityAndTourism' | translate }}</option>
                    <option value="Human Services">{{ 'header.humanServices' | translate }}</option>
                    <option value="Information Technology">{{ 'header.informationTechnology' | translate }}</option>
                    <option value="Law, Public Safety, Corrections and Security">{{ 'header.lawPublicSafetyCorrectionsAnd' | translate }}
                      {{ 'header.security' | translate }}</option>
                    <option value="Manufacturing">{{ 'header.manufacturing' | translate }}</option>
                    <option value="Marketing, Sales and Service">{{ 'header.marketingSalesAndService' | translate }}</option>
                    <option value="Science, Technology, Engineering and Mathematics">{{ 'header.scienceTechnology' | translate }}
                      {{ 'header.engineeringAndMathematics' | translate }}</option>
                    <option value="Transportation, Distribution and Logistics">{{ 'header.transportationDistributionAnd' | translate }}
                      {{ 'header.logistics' | translate }}</option>
                    <option value="Others">{{ 'header.others' | translate }}</option>
                  </select>
                  <label for="admission-guardian-occupation">{{ 'header.occupation' | translate }}</label>
                </div>
                <div class="form-group">
                  <input (change)="changeGuardQual(mGuardianQualification)" [(ngModel)]="mGuardianQualification"
                    [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="guar-qual"
                    placeholder="{{ 'header.qualification' | translate }}">
                  <label for="guar-qual">{{ 'header.educationalQualification' | translate }}</label>
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" id="guardian-annual-income"
                    [(ngModel)]="addNewStudentGuardianAnnualIncome" [ngModelOptions]="{standalone: true}"
                    (keydown)="handleKeyDown($event)" placeholder="{{ 'header.amount' | translate }}">
                  <label for="regular2">{{ 'header.annualIncome' | translate }}</label>
                </div>
                <div class="form-group">
                  <input [(ngModel)]="addNewGuardianPinCode" [ngModelOptions]="{standalone: true}"
                    class="form-control" id="guardian-pincode" maxlength="6" type="text"
                    (keydown)="handleKeyDown($event)" placeholder="{{ 'header.pincode' | translate }}">
                  <label for="mother-pincode">{{ 'header.pinCode' | translate }} </label>
                </div>
                <div class="form-group adv2-span-full">
                  <div class="checkbox checkbox-styled">
                    <label>
                      <input (change)="mGuardianSameFatherAddressClick()" [(ngModel)]="mGuardianSameFatherAddress"
                        [ngModelOptions]="{standalone: true}" type="checkbox" value="">
                      <span>{{ 'header.useFathersAddressAndPinCode' | translate }}</span>
                    </label>
                  </div>
                </div>
                <div class="form-group adv2-span-full">
                  <textarea (change)="changeGuarAdd(mGuardianAddress)" [(ngModel)]="mGuardianAddress"
                    [ngModelOptions]="{standalone: true}" name="textarea1" id="guard-staddress" class="form-control"
                    rows="3" placeholder="{{ 'header.address' | translate }}">{{mGuardianAddress}}</textarea>
                  <label for="guard-staddress">{{ 'header.contactAddress' | translate }}</label>
                </div>
              </div>
            </div>
          </section>

          <!-- ============ STEP 5: Review / Finish ============ -->
          <section class="adv2-panestep" [class.active]="currentStep === 5" [hidden]="currentStep !== 5">
            <div class="adv2-section-card adv2-finish-card">
              <div class="adv2-review-wrap">
                <div class="adv2-review-photo-col">
                  <div class="cropme-admission student-image adv2-photo-frame">
                    <img src="assets/img/avatar-students.png" id="studentimageadmission" class="img-responsive">
                  </div>
                  <div class="adv2-photo-actions">
                    <h5 class="progress hide" id="studentadmsson-progressbar">
                      {{ 'header.uploading' | translate }}</h5>
                    <input type="file" class="input-style" id="openfileadmission" style="width:1px; height: 1px">
                    <h5 (click)="openBrowserToUplaodPhotoAddmission()" class="image-edit hide adv2-photo-edit" id="hide-txt-foradmsn">
                      {{ 'header.uploadStudentImage' | translate }}</h5>
                  </div>
                </div>

                <div class="adv2-review-info-col">
                  <p class="adv2-finish-lead">{{ 'header.hereYouGoWithNewAdmission' | translate }}</p>
                  <h4 class="adv2-finish-subtext">{{ 'header.clickFinishToCompleteTheAdmission' | translate }}</h4>

                  <div class="adv2-review-summary">
                    <div class="adv2-review-item" title="{{ reviewStudentName }}">
                      <span class="adv2-review-label">{{ 'header.student' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewStudentName }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewGender }}">
                      <span class="adv2-review-label">{{ 'header.gender' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewGender }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewDOB }}">
                      <span class="adv2-review-label">{{ 'header.dateOfBirth' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewDOB }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewBloodGroup }}">
                      <span class="adv2-review-label">{{ 'header.bloodGroup' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewBloodGroup }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewReligion }}">
                      <span class="adv2-review-label">{{ 'header.religion' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewReligion }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewNationality }}">
                      <span class="adv2-review-label">{{ 'header.nationality' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewNationality }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewCasteCategory }}">
                      <span class="adv2-review-label">{{ 'header.casteCategory' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewCasteCategory }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewStudentContact }}">
                      <span class="adv2-review-label">{{ 'header.contactNumber' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewStudentContact }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewStudentEmail }}">
                      <span class="adv2-review-label">{{ 'header.studentEmail' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewStudentEmail }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewAadharNumber }}">
                      <span class="adv2-review-label">{{ brand.nationalIdFieldLabelKey | translate }}</span>
                      <span class="adv2-review-value">{{ reviewAadharNumber }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewAcademicYear }}">
                      <span class="adv2-review-label">{{ 'header.academicYear' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewAcademicYear }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewAdmissionBase }}">
                      <span class="adv2-review-label">{{ 'header.admissionBase' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewAdmissionBase }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewFeesCategory }}">
                      <span class="adv2-review-label">{{ 'header.feesCategory' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewFeesCategory }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewClassName }} {{ reviewClassSectionName !== '—' ? '- ' + reviewClassSectionName : '' }}">
                      <span class="adv2-review-label">{{ 'header.class' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewClassName }} {{ reviewClassSectionName !== '—' ? '- ' + reviewClassSectionName : '' }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewAdmissionDate }}">
                      <span class="adv2-review-label">{{ 'header.admissionDate' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewAdmissionDate }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewFatherName }}">
                      <span class="adv2-review-label">{{ 'header.fathersName' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewFatherName }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewFatherContact }}">
                      <span class="adv2-review-label">{{ 'header.fathersContact' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewFatherContact }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewMotherName }}">
                      <span class="adv2-review-label">{{ 'header.mothersName' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewMotherName }}</span>
                    </div>
                    <div class="adv2-review-item" title="{{ reviewGuardianName }}">
                      <span class="adv2-review-label">{{ 'header.guardiansName' | translate }}</span>
                      <span class="adv2-review-value">{{ reviewGuardianName }}</span>
                    </div>
                  </div>

                  <div class="adv2-finish-submit">
                    <button id="admissionbtndisable" (click)="finishAdmissionProcess1()" type="button"
                      class="btn btn-raised ink-reaction btn-info adv2-finish-btn" data-toggle="dropdown" aria-expanded="false">
                      <i class="ph-bold ph-check-circle"></i>
                      {{ 'header.finish' | translate }}
                    </button>
                    <div id="new-student-admission-progress-div" class="progress hide adv2-progress-bar-wrap">
                      <span id="new-student-admission-percent-text" class="adv2-progress-text"></span>
                      <div id="new-student-admission-percent-progress"
                        class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar"
                        aria-valuenow="40" aria-valuemin="0" aria-valuemax="100">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </form>
      </div>

      <!-- Sticky footer -->
      <div class="adv2-mfoot" *ngIf="!showPostAdmissionDocumentsStep">
        <span class="adv2-step-counter">{{ 'header.stepCounter' | translate: { current: currentStep, total: totalSteps } }}</span>
        <div class="adv2-mfoot-actions">
          <button type="button" class="adv2-btn adv2-btn-secondary" *ngIf="currentStep > 1" (click)="prevStep()">
            <i class="ph-bold ph-arrow-left"></i> {{ 'header.back' | translate }}
          </button>
          <button type="button" class="adv2-btn adv2-btn-primary" *ngIf="currentStep < totalSteps" (click)="nextStep()">
            {{ 'header.next' | translate }} <i class="ph-bold ph-arrow-right"></i>
          </button>
        </div>
      </div>

      <div class="adv2-mfoot" *ngIf="showPostAdmissionDocumentsStep">
        <span class="adv2-step-counter">{{ 'header.supportingDocuments' | translate }}</span>
        <div class="adv2-mfoot-actions">
          <button type="button" class="adv2-btn adv2-btn-primary" (click)="finishPostAdmissionDocumentsStep()">
            {{ 'header.finish' | translate }}
          </button>
        </div>
      </div>

    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->

  <div class="adv2-doc-preview-overlay" *ngIf="isDocumentPreviewOpen" (click)="closeDocumentPreview()">
    <button type="button" class="adv2-doc-preview-close-btn" (click)="closeDocumentPreview()">
      <i class="ph ph-x"></i>
    </button>
    <div class="adv2-doc-preview-content" [class.adv2-doc-preview-content-doc]="documentPreviewType === 'document'"
      (click)="$event.stopPropagation()">
      <ng-container *ngIf="documentPreviewType === 'image'; else adv2DocumentPreview">
        <img [src]="documentPreviewUrl" [alt]="documentPreviewLabel" class="adv2-doc-preview-image" />
      </ng-container>
      <ng-template #adv2DocumentPreview>
        <iframe [src]="documentPreviewSafeUrl" class="adv2-doc-preview-iframe" title="{{ 'header.documentPreview' | translate }}"></iframe>
      </ng-template>
      <div class="adv2-doc-preview-label">{{ documentPreviewLabel }}</div>
    </div>
  </div>
</div><!-- /.modal -->
